import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { BaseDataService, ConfirmationDialogButtons, DatePickerPopup2Component, ErrorHandlerService, ModalService, ModelData, NotificationService } from 'yt-ng-framework';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { Attachment } from './attachment';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Console } from 'console';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-send-edokument',
  templateUrl: './send-edokument.component.html'
})
export class SendEdokumentComponent implements OnInit {

  @Input() Parameters;
  modelData: ModelData;
  Config={};
  items: Attachment[] = [];
  submitted = false;  
  files: any[] = [];
  messages: string[] = [];
  filesLength: any;
  filesCount: any;
  loadingSendEUInvoice: boolean = false;
  // @ViewChild('dtpDatumSmanjenja', { static: false }) dtpDatumSmanjenja: DatePickerPopup2Component;


  constructor(
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected modalService: ModalService,
    protected errorService: ErrorHandlerService
  ) { }

  ngOnInit() {
    this.files = [];
    this.filesLength = 0;
    this.filesCount = 0;
  }

  ngAfterViewInit() {
    // if (this.Parameters[2].Value == 'ko') {
    //   setTimeout(() => {
    //     const dateNow = new Date();
    //     this.dtpDatumSmanjenja.value = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
    //     const el = this.dtpDatumSmanjenja.errorIcon.nativeElement;
    //     if (el) {
    //       el.style.left = null; // ili 'auto'
    //     }
    //   });
    // }
  }
  OsveziListu(){
    this.Config={
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: true
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: false
      }
      ,BreadCrumble: this.modelData.BreadcrumbLabel
      ,Height: 'auto'
    }
  }

  SendEDokument() {
    this.submitted = true;
    // if (this.Parameters[2].Value == 'ko' && this.dtpDatumSmanjenja.value == null)
    //   return false;

    this.loadingSendEUInvoice=true;
    let parameters = {
      fakdokumentID: this.Parameters[0].Value, masterDokumID: this.Parameters[1].Value,
      attachments: this.items, genericName: this.Parameters[2].Value, brojDecimala: this.Parameters[3].Value
      // datumSmanjenja: this.dtpDatumSmanjenja ? this.dtpDatumSmanjenja.value : null
    };

      this.baseDataService.GetFile('FakDokument', 'SendEUInvoice', parameters)
        .subscribe((result : any) =>{
          this.loadingSendEUInvoice=false;  
          this.translateService.get(["EDOKUMENT.SENT.SUCESS"])
          .subscribe(translate => {
            // this.notificationService.success(translate["EDOKUMENT.SENT.SUCESS"]);
            this.toastrService.success(translate["EDOKUMENT.SENT.SUCESS"]);
            this.activeModal.close(true);   
          })
        }        
        ,error => {
          this.loadingSendEUInvoice=false; 
          // throw error;   
          let _message;   
          let translatedMessage: string = "";     
          if(error instanceof HttpErrorResponse){
            _message = this.errorService.getServerMessage(error);
            if (_message instanceof ArrayBuffer){
              // _message = String.fromCharCode.apply(null, new Uint8Array(_message));   
              _message = new TextDecoder('utf-8').decode(new Uint8Array(_message));
              let message: string = _message;
              if (message.includes("EDOKUMENT")){
                let messageArray: string[] = message.split(';');   
                messageArray.forEach((element, index) => {
                  messageArray[index] = "FW.ERRORS." + element;
                });
                this.translateService.get(messageArray)
                .subscribe(translate => {
                  translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                });
              }
              else
                translatedMessage = message;              
            }
            else{
              translatedMessage = this.errorService.getClientMessage(error);
            }
          }
               this.modalService.ShowConfirmationDialog("Problemi kod slanja", translatedMessage, "warning", ConfirmationDialogButtons.Ok);
          
        })  
  }

  

  Close(){
    this.activeModal.dismiss();
  }

  
  onFileChange(event) {
    
     const MAX_SIZE: number = 25000000;
     const MAX_FILES: number = 2;
    
     this.filesCount = this.filesCount + event.target.files.length;

     if (event.target.files && event.target.files.length > 0) {     
      for (let index = 0; index < event.target.files.length; index++) {
        let fileLength = event.target.files[index].size;
        this.filesLength += fileLength;
        

        if (this.filesCount > MAX_FILES) {
          this.translateService.get(['EDOKUMENT.ATTACHMENT.WARN', 'EDOKUMENT.ATTACHMENT.OVERCOUNT2'])
          .subscribe(translate => {
            // this.notificationService.warn(translate['EDOKUMENT.ATTACHMENT.WARN'], translate['EDOKUMENT.ATTACHMENT.OVERCOUNT2']);
            this.toastrService.warning(translate['EDOKUMENT.ATTACHMENT.WARN'], translate['EDOKUMENT.ATTACHMENT.OVERCOUNT2']);
          });
          this.filesCount = this.files.length;
          return;
        }
    

        if (this.filesLength > MAX_SIZE) {
          this.translateService.get(['EDOKUMENT.ATTACHMENT.WARN', 'EDOKUMENT.ATTACHMENT.LARGEFILE'])
          .subscribe(translate => {
            // this.notificationService.warn(translate['EDOKUMENT.ATTACHMENT.WARN'], translate['EDOKUMENT.ATTACHMENT.LARGEFILE']);
            this.toastrService.warning(translate['EDOKUMENT.ATTACHMENT.WARN'], translate['EDOKUMENT.ATTACHMENT.LARGEFILE']);
          });
          this.filesLength = 0;
          return;
        }

        
      }
      for (let index = 0; index < event.target.files.length; index++) {
          let file = event.target.files[index];
          this.files.push(file);
          this.readAndUploadFile(event.target.files[index]);
       }
     
    }
    else{
      this.translateService.get(['EDOKUMENT.ATTACHMENT.WARN', 'EDOKUMENT.ATTACHMENT.NOFILE'])
          .subscribe(translate => {
            // this.notificationService.warn(translate['EDOKUMENT.ATTACHMENT.WARN'], translate['EDOKUMENT.ATTACHMENT.NOFILE']);
            this.toastrService.warning(translate['EDOKUMENT.ATTACHMENT.WARN'], translate['EDOKUMENT.ATTACHMENT.NOFILE']);
          });
      return;
    }
    
  }

  private readAndUploadFile(theFile: any) {
    let file = new Attachment();
    
    // Set File Information
    file.fileName = theFile.name;
    file.fileSize = theFile.size;
    file.fileType = theFile.type;

    var formData = new FormData();
    formData.append('file', theFile, theFile.name);
    this.baseDataService.Post('FakDokument', "uploadPDF2", formData, null, null)
    .subscribe(fileLocation => { 
      if(fileLocation){
        file.fileLocation = fileLocation.toString();
        this.items.push(file);
        this.OsveziListu();
      }
    });

    
  }

  uploadFile(): void {
    for (let index = 0; index < this.files.length; index++) {
      this.readAndUploadFile(this.files[index]);
    }
   
   
  }

  deleteItem(item : Attachment){
    this.baseDataService.Post('FakDokument', 'deleteFileFromServer',{location : item.fileLocation}, null, null)
    .subscribe((result) =>{
      if (result.toString() == "200"){
        this.items.splice(this.items.indexOf(item), 1);
        this.OsveziListu();
        this.files = this.files.filter(file => file.name != item.fileName);
        this.filesCount = this.files.length;
      }
      })
    }

}


